const baron = require("baron");
module.exports.init_scrollbar = () => {
    baron({
        root: '.baron',
        scroller: '.baron__scroller',
        bar: '.baron__bar'
    });
}
